import { MultiSelectDropdown } from 'components/common'
import { memo, useEffect, useState } from 'react'
import { fetchChains } from 'utils/api/chainApi'

type Props = {
  setValue: any
  resetForm: any
  error?: string
  label: string
  name: string
  required?: boolean
  defaultSelected?: []
  isActive?: boolean
  disabled?: boolean
}

const MultiSelectChainDropdown = ({
  setValue,
  error,
  label,
  name,
  required = false,
  defaultSelected,
  isActive,
  resetForm,
  disabled = false,
}: Props) => {
  const [options, setOptions] = useState<any>([])
  const [loading, setLoading] = useState<boolean>(true)

  const getChains = async () => {
    try {
      const { data } = await fetchChains({
        limit: 500,
        page: 1,
        isActive,
      })
      const chains = data?.docs?.map((chain: any) => ({
        label: chain.chainName,
        value: chain._id,
        disabled: false,
      }))

      if (!chains || chains.length <= 0) {
        return setOptions([])
      }
      setOptions(chains)
    } catch (error) {
      setOptions([])
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getChains()
  }, [])

  if (loading) {
    return <></>
  }

  return (
    <MultiSelectDropdown
      required={required}
      label={label}
      name={name}
      setValue={setValue}
      error={error}
      includeSelectAll={options?.length > 0}
      defaultSelected={defaultSelected}
      disabled={disabled}
      options={
        options.length <= 0
          ? [
              {
                label: 'No Chains Found',
                value: 'NO_CHAINS',
                disabled: true,
              },
            ]
          : options
      }
      reset={resetForm}
    />
  )
}

export default memo(MultiSelectChainDropdown)
